module.exports = __webpack_public_path__ + "static/grokking-algos-34e52e30f35add02718dec371dafb406.jpeg";